export default "/images/expo.png?28b524b689ef8b4d45cf127838f6bad1";